<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.discounts') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ discounts }}</pre> -->

      <div
        v-if="ready"
        class="col-md-12 no-padding">
        <table
          id="dataTable"
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th>{{ $t('message.discount') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.type') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.discount_amount') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.assignitems') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in discounts">
              <td>
                <router-link
                  :to="{
                    name: 'DiscountEdit',
                    query: {
                      discount_id: item.discount_id,
                      discount_name: item.discount_name
                    }
                }">
                  {{ item.discount_name }}
                </router-link>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                <span v-if="item.type === 'general'">{{ $t('message.discountgeneral') }}</span>
                <span v-else>{{ $t('message.discountcondition') }}</span>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                <template v-if="item.type === 'general'">
                  <template v-if="item.value_type == 'percentage'">
                    {{ item.value_amount }}%
                  </template>
                  <template v-if="item.value_type == 'number'">
                    {{ currency }} {{ item.value_amount }}
                  </template>
                </template>
                <template v-else>
                  {{ getConditionsAmountText(item.conditions) }}
                </template>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                {{ item.assign.length }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'DiscountAll',
  data () {
    return {
      ready: false,
    }
  },
  computed: mapGetters({
    discounts: 'getDiscounts',
    currency: 'getCurrency',
  }),
  mixins: [userPermissionMixin],
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    // get discounts
    await this.$store.dispatch('getDiscounts')
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearDiscounts'])
  },
  methods: {
    getConditionsAmountText (conditions) {
      return conditions.reduce((arr, next) => {
        if (next.value_type === 'percentage') {
          arr.push(`${next.value_amount}%`)
        } else {
          arr.push(`${this.currency} ${next.value_amount}`)
        }
        return arr
      }, []).join(', ')
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/items/discount/All.vue